export default {
  // 简体
  0: {
    upcoming: '未开始',
    ongoing: '进行中',
    settled: '已结束',
    closed: '已截止',
    settling: '已截止',
    participantUnit: '人',
    participantUnits: '人',
    countdownLabel: '距活动截止: ',
    unitDay: '天',
    unitHour: '时',
    unitMinute: '分',
    unitSecond: '秒',
    settlingLabel: '结算中...',
    announceLabel: '公布结果: ',
    resultWin: '恭喜您！分析中了',
    resultWinPredict: '恭喜您！预测中了',
    resultWinClosest: '恭喜您！分析最接近',
    resultWinClosestPredict: '恭喜您！预测最接近',
    resultLose: '很遗憾，分析错了',
    resultLosePredict: '很遗憾，预测错了',
    resultPush: '本次为平局',
    resultNotJoined: '您未参与本次分析',
    resultNotJoinedPredict: '您未参与本次预测',
    reasonPopupTitle: '选择理由',
    reasonPopupSubmit: '提交',
    actualResult: '本次结果',
    finalResult: '最终结果',
    myAnalysis: '我的分析',
    myPrediction: '我的预测',
    analyzeCta: '立即分析',
    predictCta: '立即预测',
    closePriceTitle: '分析收盘价',
    closePriceTitlePredict: '预测收盘价',
    actualTrend: '实际走势',
    actualTrendUp: '涨',
    actualTrendDown: '跌',
    actualTrendPush: '平',
    watchAdded: '已添加至自选',
    watchRemoved: '已从自选中移除',
    yesterdayClose: '昨日收盘价',
    todayCloseLabel: '今日收盘价',
    closeLabel: '收盘价',
    inputPlaceholder: '请输入',
    currentPriceLabel: '现价',
    closePriceSubmit: '提交修改',
    aboveCurrentPrice: '高于现价',
    belowCurrentPrice: '低于现价',
  },

  // 繁体
  1: {
    upcoming: '未開始',
    ongoing: '進行中',
    settled: '已結束',
    closed: '已截止',
    settling: '已截止',
    participantUnit: '人',
    participantUnits: '人',
    countdownLabel: '距活動截止: ',
    unitDay: '天',
    unitHour: '時',
    unitMinute: '分',
    unitSecond: '秒',
    settlingLabel: '結算中...',
    announceLabel: '揭曉結果: ',
    resultWin: '恭喜！睇中咗',
    resultWinPredict: '恭喜！睇中咗',
    resultWinClosest: '恭喜！分析最接近',
    resultWinClosestPredict: '恭喜！預測最接近',
    resultLose: '好可惜，睇錯咗',
    resultLosePredict: '好可惜，睇錯咗',
    resultPush: '本次為平局',
    resultNotJoined: '你未有參與本次分析',
    resultNotJoinedPredict: '你未有參與本次預測',
    reasonPopupTitle: '選擇理由',
    reasonPopupSubmit: '提交',
    actualResult: '本次結果',
    finalResult: '最終結果',
    myAnalysis: '我的分析',
    myPrediction: '我的預測',
    analyzeCta: '立即分析',
    predictCta: '立即預測',
    closePriceTitle: '分析收盤價',
    closePriceTitlePredict: '預測收盤價',
    actualTrend: '實際走勢',
    actualTrendUp: '升',
    actualTrendDown: '跌',
    actualTrendPush: '平',
    watchAdded: '已加入自選',
    watchRemoved: '已從自選中移除',
    yesterdayClose: '昨日收盤價',
    todayCloseLabel: '今日收盤價',
    closeLabel: '收盤價',
    inputPlaceholder: '請輸入',
    currentPriceLabel: '現價',
    closePriceSubmit: '提交修改',
    aboveCurrentPrice: '高於現價',
    belowCurrentPrice: '低於現價',
  },

  // 英文
  2: {
    upcoming: 'Upcoming',
    ongoing: 'Ongoing',
    settled: 'Settled',
    closed: 'Closed',
    settling: 'Closed',
    participantUnit: ' Participant',
    participantUnits: ' Participants',
    countdownLabel: 'Closes in：',
    unitDay: 'd',
    unitHour: 'h',
    unitMinute: 'm',
    unitSecond: 's',
    settlingLabel: 'Settling...',
    announceLabel: 'Announcement: ',
    resultWin: 'You called it!',
    resultWinPredict: 'You called it!',
    resultWinClosest: 'You called it!',
    resultWinClosestPredict: 'Congrats! Closest prediction!',
    resultLose: 'Better luck next time!',
    resultLosePredict: 'Better luck next time!',
    resultPush: 'This one was a draw.',
    resultNotJoined: 'You sat this one out.',
    resultNotJoinedPredict: 'You sat this one out.',
    reasonPopupTitle: 'Select a reason',
    reasonPopupSubmit: 'Submit',
    actualResult: 'Result',
    finalResult: 'Final Result',
    myAnalysis: 'My Analysis',
    myPrediction: 'My Prediction',
    analyzeCta: 'Analyze Now',
    predictCta: 'Predict Now',
    closePriceTitle: 'Analyze Closing Price',
    closePriceTitlePredict: 'Predict Closing Price',
    actualTrend: 'Actual',
    actualTrendUp: 'Up',
    actualTrendDown: 'Down',
    actualTrendPush: 'Flat',
    watchAdded: 'Added to Watchlist',
    watchRemoved: 'Removed from Watchlist',
    yesterdayClose: "Yesterday's closing price",
    todayCloseLabel: "Today's Close",
    closeLabel: 'Closing Price',
    inputPlaceholder: 'Enter price',
    currentPriceLabel: 'Current Price',
    closePriceSubmit: 'Submit',
    aboveCurrentPrice: 'Above current',
    belowCurrentPrice: 'Below current',
  },
};
